import { LOCALES } from './locales'

export const messages = {
  [LOCALES.ENGLISH]: {
    language: "Language",
    sign_in: `Sign In`,
    sign_out: `Sign Out`,
    registration: "Registration",
    sign_up: "Sign Up",
    password: "Password",
    username: "Username",
    email: "Email",
    contact_us: 'Contact us',

    dashboard: "Dashboard",
    note: "Note",
    notes: "Notes",
    all_notes: "All notes",
    create_note: "Create note",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    management: "Management",
    categories: "Catgories",
    select_category:"Select category",
    create_category:"Create category",
    create_tag:"Create tag",
    tags: "Tags",
    tags_management:"Tags management",

    alert_note_saved: "Note saved",
    alert_note_deleted: "Note deleted",
    you_registered_successfully: "You registered successfully",

    title: "Title",
    field_required: "Required field"
  },

  [LOCALES.RUSSIAN]: {
    language: "Язык",
    sign_in: `Войти`,
    sign_out: `Выйти`,
    registration: "Регистрация",
    sign_up: "Зарегистрироваться",
    password: "Пароль",
    username: "Имя пользователя",
    email: "Имейл",
    contact_us: 'Свяжитесь с нами',

    dashboard: "Главная",
    note: "Заметка",
    notes: "Заметки",
    all_notes: "Все заметки",
    create_note: "Создать заметку",
    create: "Создать",
    edit: "Редактировать",
    delete: "Удалить",
    save: "Сохранить",
    cancel: "Отменить",
    management: "Управление",
    categories: "Разделы",
    select_category:"Выбрать раздел",
    create_category:"Создать раздел",
    create_tag:"Создать тэг",
    tags: "Тэги",
    tags_management:"Управление тэгами",

    alert_note_saved: "Заметка созранена",
    alert_note_deleted: "Заметка удалена",
    you_registered_successfully: "Вы успешно зарегистрировались",

    title: "Название",

    field_required: "Обязательное поле"
  }
}